import script from "./ProgressBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProgressBar.vue?vue&type=script&lang=ts&setup=true"

import "./ProgressBar.vue?vue&type=style&index=0&id=da0fad24&lang=scss"

const __exports__ = script;

export default __exports__